import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import * as CoursesActions from './courses.actions';
import * as CoursesSelectors from './courses.selectors';

@Injectable()
export class CoursesFacade {
  courses$ = this._store.pipe(
    select(CoursesSelectors.getCoursesLoaded),
    filter(courses => !!courses)
  );

  steps$ = this._store.pipe(
    select(CoursesSelectors.getStepsLoaded),
    filter(steps => !!steps)
  );

  loaded$ = this._store.pipe(
    select(CoursesSelectors.getLoaded),
    filter(loaded => !!loaded)
  );

  constructor(private readonly _store: Store) {}

  blocks$ = (courseId: string) =>
    this._store.pipe(
      select(CoursesSelectors.getStepBlocksLoaded(courseId)),
      filter(blocks => !!blocks)
    );

  getCourses(): void {
    this._store.dispatch(CoursesActions.loadCourses());
  }

  getStepBlocks(courseId: string, groupId: string): void {
    this._store.dispatch(CoursesActions.loadStepBlocksByCourse({ courseId, groupId }));
  }

  getSteps(stepId: string, groupId: string): void {
    this._store.dispatch(CoursesActions.loadSteps({ stepId, groupId }));
  }
}
